/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/no-unescaped-entities */
import Footer from "@buddieshr/components/footer";
import Header from "@buddieshr/components/header";
import MetaHeader from "@buddieshr/components/metaHeader";
import PageWrapper from "@buddieshr/components/templates/pageWrapper";
import { useRouter } from "next/router";
import React from "react";
import styles from "@buddieshr/styles/use-cases/index.module.scss";
import { Button, Tag } from "antd";
import TextBackground from "@buddieshr/components/text/textBackground";
import Image from "next/image";
import AddToSlackButton from "@buddieshr/components/addToSlackButton";
import { PRODUCTS } from "@buddieshr/utils/constants-products";
import PricingButtonHint from "@buddieshr/components/pricing/pricingbuttonHint";
import Link from "next/link";
import { CrownOutlined } from "@ant-design/icons";
import G2Logos from "@buddieshr/components/g2Logos";

const Celebrations = () => {
  const router = useRouter();

  const app = PRODUCTS.find((p) => p.slug === "billy");
  const appClappy = PRODUCTS.find((p) => p.slug === "clappy");

  return (
    <>
      <MetaHeader
        title={"Slack app for Team Celebrations | BuddiesHR"}
        description={
          "Celebrate milestones together. Use BuddiesHR Slack app to get birthday and work anniversary reminders."
        }
        currentURL={`https://buddieshr.com/${
          router.locale === "en" ? "" : router.locale
        }/use-cases/celebrations`}
        currentShare={`https://buddieshr.com/img/share_preview_1.png`}
        pageSlug={`use-cases/celebrations`}
        locale={router.locale}
      />
      <Header />
      <div className={styles.container}>
        <PageWrapper width={800}>
          <div className={styles.titlePanel}>
            <div className={styles.tagWrapper}>
              <Tag
                size="large"
                color="blue"
                bordered={false}
                style={{
                  fontSize: 16,
                  padding: "4px 16px",
                  fontWeight: "bold",
                }}
              >
                USE CASE
              </Tag>
            </div>
            <h1 className={styles.title}>Celebrate milestones in Slack</h1>
            <p className={styles.subtitle}>
              Celebrate birthdays, work anniversaries and other milestones in
              Slack thanks to BuddiesHR. Get reminders to make sure you don't
              forget anyone's special moment and send Kudos easily. In this page
              you'll learn why it's important to celebrate as a team, why Slack
              is the perfect place for that and how to concretly send
              celebration messages thanks to Buddies.
            </p>
            <div className={styles.topCta}>
              <div className={styles.topCtaContainer}>
                <Link
                  href={"/get-started"}
                  title={"get started for celebration culture"}
                >
                  <Button
                    size="large"
                    type="primary"
                    style={{ minWidth: "320px", width: "auto", marginLeft: 16 }}
                  >
                    Get Started
                  </Button>
                </Link>
                <PricingButtonHint />
              </div>
            </div>
          </div>
          <Image
            className={styles.topIconLeft}
            src="/img/animated-emojis/Party%20Popper.png"
            alt="Party Popper"
            width="125"
            height="125"
          />

          {/* <Image
            
            alt="Speech Balloon"
            width="125"
            height="125"
            className={`${styles.topIconRight} ${styles.topIconRightRecog}`}
          /> */}
        </PageWrapper>

        <div className={styles.section}>
          <PageWrapper width={800}>
            <Image
              src="/img/animated-emojis/Partying%20Face.png"
              alt="Partying Face"
              width="138"
              height="138"
              className={`${styles.ear} ${styles.earRight}`}
            />
            <h2>
              Why is it important to celebrate milestones with your Team?{" "}
            </h2>
            <p>
              Celebrating birthdays, work anniversaries or projects is key to
              having a good company culture. It's one of the things that are
              really must-haves for remote and hybrid companies.
              <br />
              It's the best effort/impact ratio you can find to increase
              employee engagement and recognition.
              <br />
              Having a culture of celebration has many benefits:
            </p>
            <ul className={styles.listBold}>
              <li>
                It boosts <TextBackground>team cohesion</TextBackground> and
                morale
              </li>
              <li>
                It bridges the gap for{" "}
                <TextBackground>distributed teams</TextBackground>
              </li>
              <li>
                It increases <TextBackground>Productivity</TextBackground>{" "}
                (Happy employees perform better)
              </li>
              <li>
                It brings some <TextBackground>fun</TextBackground> into
                everyday routine
              </li>
            </ul>
            <br />
            <br />
            <h2>Why slack is the right place for celebrating milestones?</h2>
            <div>
              <div className={styles.slackRightPlaceElement}>
                <div className={styles.iconLeft}>✅</div>
                <div className={styles.textRightPlaceElement}>
                  Slack is the most efficient way to send Kudos and celebrate
                  birthdays and other events because{" "}
                  <b>it's easy to send a public message seend by everyone.</b>
                </div>
              </div>
              <div className={styles.slackRightPlaceElement}>
                <div className={styles.iconLeft}>✅</div>
                <div className={styles.textRightPlaceElement}>
                  <b>It's easy to react and comment</b> to the announcements.
                </div>
              </div>
              <div className={styles.slackRightPlaceElement}>
                <div className={styles.iconLeft}>✅</div>
                <div className={styles.textRightPlaceElement}>
                  Posting recognitions and celebration messages directly in the
                  context of Slack without having to sign-in to any extra
                  account or click on a link makes sure that{" "}
                  <b>everyone can see it and react</b>
                </div>
              </div>

              <div className={styles.slackRightPlaceElement}>
                <div className={styles.iconLeft}>✅</div>
                <div className={styles.textRightPlaceElement}>
                  <b>Slack is where culture happens.</b>
                </div>
              </div>
            </div>
          </PageWrapper>
        </div>
        <div className={`${styles.section} ${styles.section2}`}>
          <PageWrapper width={800}>
            <Image
              src="/img/animated-emojis/Clapping%20Hands.png"
              alt="Writing Hand"
              width="138"
              height="138"
              className={styles.writing}
            />
            <h2>How Buddieshr can be used to celebrate employees?</h2>
            <p>
              By installing <b>Billy Birthday</b> and <b>Clappy Kudos</b> Slack
              apps from BuddiesHR, you'll be able to send employee recognition
              and automate birthday and work anniversary celebrations.
              <br />
              <br />
              Here are the steps to start celebrating Employees in Slack:
            </p>
            <ul className={styles.listBold}>
              <li>
                <TextBackground>Step 1</TextBackground>: Install{" "}
                <Link target="_blank" href={app.installSlackLink}>
                  Billy Birthday for Slack
                </Link>
                {" and "}
                <Link target="_blank" href={appClappy.installSlackLink}>
                  Clappy Kudos for Slack
                </Link>
              </li>
              <li>
                <TextBackground>Step 2</TextBackground>: Go through the setup
                flow of each of the apps.
              </li>
              <li>
                <TextBackground>Step 3</TextBackground>: Send your first
                Recognition to lead the way and wait for the next celebration to
                be automatically posted 🙌
              </li>
            </ul>
            <div className={styles.Screens_wrapper}>
              <div className={styles.Screen_capture_2}>
                <Image
                  src="/img/apps/billy/preview-format.png"
                  alt="celebrate birthday in Slack"
                  title="celebrate birthday in Slack"
                  className={styles.Screen_capture}
                  width={333}
                  height={326}
                />
              </div>
            </div>

            <div className={styles.picturesProductWrapper}>
              <div className={styles.picturesProductInnerClappy}>
                <Image
                  width={744}
                  height={883}
                  className={styles.picturesProductLeft}
                  src="/img/apps/clappy/screens/give-reco.png"
                  alt="kudos in slack"
                />
                <Image
                  width={1600}
                  height={800}
                  className={styles.picturesProductRight}
                  src="/img/apps/clappy/screens/screen.png"
                  alt="praise in slack"
                />
              </div>
            </div>
            <br />
            <br />
            <h2>
              Why Billy and Clappy are the best options for celebrating
              milestones as a team?
            </h2>
            <p>
              Clappy has all the features to make employee recognition easy.
              It's fully integrated into Slack:
            </p>
            <ul className={styles.listBold}>
              <li>
                Automate Birthday and work anniversary celebrations in a few
                clicks. Drop the hustle of having to organize and write unique
                messages.
              </li>
              <li>
                Create a culture of Kudos, Praise and Recognition thanks to
                Clappy. Activate leaderboards and add rewards to push people to
                use it on the long run.
              </li>
              <li>
                Let Billy choose the best GIFs and funny messaging to announce
                the celebrations.
              </li>
              <li>
                {
                  "Employees don't leave Slack to use Clappy or Billy and don't have to create any other account."
                }
              </li>
            </ul>
            <div className={styles.cta}>
              <Link href="/billy" alt="slack birthday bot">
                <Button type="primary" size="large" style={{ minWidth: 200 }}>
                  Learn more about Billy
                </Button>
              </Link>
              &nbsp; &nbsp; &nbsp;
              <Link href="/clappy" alt="slack recognition and kudos">
                <Button type="primary" size="large" style={{ minWidth: 200 }}>
                  Learn more about Clappy
                </Button>
              </Link>
            </div>
            <div style={{ marginTop: 44 }}>
              <h3 style={{ textAlign: "center", color: "#628fa2" }}>
                Clappy and Billy are top performing apps on Slack
              </h3>
              <G2Logos
                withTitle={false}
                withBackground={false}
                style={{ marginBottom: 0 }}
                className={styles.blackone}
              />
            </div>
          </PageWrapper>
        </div>
        <PageWrapper width={900}>
          <div className={styles.installWrapper}>
            <div
              className={`${styles.installInner} ${styles.installInnerClappy}`}
            >
              <div className={styles.installContentContainer}>
                <div>
                  <Image
                    src="/img/animated-emojis/Partying%20Face.png"
                    alt="Partying Face"
                    width="125"
                    height="125"
                  />
                </div>
                <div className={styles.installContentRight}>
                  <h2>Celebrate together in Slack</h2>
                  <div>No external tool to sign-up to, very simple set up.</div>
                  <div style={{ marginTop: 18 }}>
                    <AddToSlackButton block app={app} />
                    <PricingButtonHint />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.faq}>
            <h2>FAQ</h2>
            <div className={styles.faqWrapper}>
              <div className={styles.faqElement}>
                <h3>How Billy knows the birth dates?</h3>
                <p>
                  Billy can either reach out to the employees asking them to
                  enter their date or Admins can import them thanks to a
                  spreadsheet template that we provide. Dates can also be
                  added/edited individually.
                </p>
              </div>
              <div className={styles.faqElement}>
                <h3>Can I customize automated birthday messages?</h3>
                <p>
                  Yes, even though messages are posted automatically. You can
                  personalize the messages beforehand.
                </p>
              </div>
            </div>
          </div>
        </PageWrapper>
      </div>

      <Footer />
    </>
  );
};

export default Celebrations;
